export default __webpack_public_path__ + "static/Bogota-disabled-a3f97e74adc01e9b3d00d01426cfee6e.svg";